import React from 'react';
import { Box, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';

const MeetingTabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box 
        sx={{ 
          p: 3, 
          padding: isMobile ? "5px 5px 5px 0px" : "24px"
        }} 
        id="customrightpanel"
      >
        <Typography component="div">{children}</Typography>
      </Box>
    )}
  </div>
);

MeetingTabPanel.displayName = 'MeetingTabPanel';

export default MeetingTabPanel; 